/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState,memo, useRef } from 'react';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import DateRangeForDropDown from './DateRangeForDropdown'; 
import VoucherTypeDropdown from './VoucherTypeDropdown';
const Filter = ({
    FilterData, radioButton,
    dateRangeFilterName,FilterCheckbox, 
    setSelectedDateRange,selectedDateRange,
    setEndDate,setStartDate,
    handleApplyFilter, selectedName,
    setIsFilterOpen,handleSelectObject,
    selectedFilter, setSelectedFilter, 
    tooltip,  filterCount, setFilterCheckBox,
    currentFinacialYear,academicYears,
    setSelectedName,searchParams,calculateEndDate,
    setSearchParams,finacialYear,ref}) => {

    const [selectedDates, setSelectedDates] = useState({})
    const [dateErrorMsg,setDateErrorMsg] = useState('')


    /**
     * The function `handleCheck` checks if the end date is earlier than the start date.
     * @returns The function `handleCheck` returns a boolean value indicating whether the `endDate` is less
     * than the `startDate`.
     */
    const handleCheck = () => {
        const startDate_1 = new Date(FilterCheckbox['start_date']);
        const endDate_2 = new Date(FilterCheckbox['end_date']);
        // Convert startDate and endDate to UTC
        let startDate = startDate_1.toDateString().split('00:')[0]
        let endDate = endDate_2.toDateString().split('00:')[0]

        if(selectedDateRange === 'Custom' && selectedFilter ==='date_range'){
            if(FilterCheckbox['start_date']===null || FilterCheckbox['end_date']===null) {
                if(FilterCheckbox['start_date']===null && FilterCheckbox['end_date']===null){
                    return false;
                } else if ((selectedDates.start_date === undefined || searchParams.get('start_date') === null ) || (selectedDates.end_date === undefined || searchParams.get('end_date') === null)){
                    setdateError(true)
                    setDateErrorMsg('Both start date and End Date are required.')
                    return true;
                }
                
            } else if ( (searchParams.get('dropname') === 'Academic Year' || searchParams.get('dropname') === 'Financial Year') && (selectedDates.start_date === undefined || selectedDates.end_date === undefined ) ) {
                setDateErrorMsg('Both Start Date and End Date are required.')
                return true
            } else if (new Date(endDate) < new Date(startDate)) {
                if(new Date(endDate) === new Date(startDate)) {
                    return false
                } else {
                    setDateErrorMsg('Start Date cannot exceed End Date')
                    return true       
                }
            } else {
                return false
            }
        } else {
            return false
        }

    }

    const closeRef = useRef();
    /* The `useOnClickOutside` hook is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the filter component. */
    useOnClickOutside(closeRef, () => {
        setIsFilterOpen(false)
    })

        
    const [dateError, setdateError] = useState(false)

    return (
        <div class={` filter_btn_drp_dwn top3 shadow-s1 ${filterCount ===0 ? '' : 'filterCnt'} filter_modal`} ref={closeRef} style={{'width':'345px'}}>
            <div class="flex h-[80%]">
                <ul class="flex list-none flex-col flex-wrap h-fit filter_btn_drp_dwn_div1 min-w-[95px]" role="tablist" data-te-nav-ref="">
                    {Object.keys(FilterData).map((item, index) => (
                        <li role="presentation" class="flex-grow text-center" key={item}>
                            <button id={item} data-test-id={index+item}
                                onClick={() => {
                                    setSelectedFilter(item); 
                                    setdateError(false)
                                }}  
                                class={`${dateRangeFilterName !== undefined ? "min-w-[130px] text-start text-sm font-normal" : "text-start relative block text-sm font-normal "} ${selectedFilter === item ? "text-[#106EB4]" : "text-[#4D555B]"} mb-3`}>{dateRangeFilterName === undefined ? item.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(c) { return c.toUpperCase(); }) : dateRangeFilterName}</button>
                        </li>))}
                </ul>
                <div class={"filter_btn_drp_dwn_div2"}>   
                    <div class="hidden transition-opacity duration-150 ease-linear data-[te-tab-active]:block opacity-100" id="tabs-home03" role="tabpanel" aria-labelledby="tabs-home-tab03" data-te-tab-active="">
                        <div class="h-[220px] overflow-auto overflow-x-hidden scroll-smooth scroll-bar">
                            <div class={"w-full"}>
                                {(selectedFilter !== "date_range" && selectedFilter !== "custom")? <div className='-mt-1'>
                                    <VoucherTypeDropdown
                                        handleSelectObject={handleSelectObject}
                                        selectedFilter={selectedFilter}
                                        searchParams={searchParams}
                                    />
                                </div>
                                    :<div className='-mt-1'>
                                        <DateRangeForDropDown 
                                            dateErrorMsg={dateErrorMsg}
                                            searchParams={searchParams}
                                            setSearchParams={setSearchParams} 
                                            selectedName={selectedName}
                                            setSelectedName={setSelectedName}
                                            finacialYear={finacialYear} 
                                            selectedDateRange={selectedDateRange}
                                            setSelectedDateRange={setSelectedDateRange}
                                            filterCount={filterCount}
                                            currentFinacialYear={currentFinacialYear}
                                            setSelectedDates={setSelectedDates} 
                                            dateError={dateError} 
                                            setEndDate={setEndDate}
                                            setStartDate={setStartDate}
                                            setdateError={setdateError} 
                                            handleCheck={handleCheck} 
                                            setFilterCheckBox={setFilterCheckBox}
                                            handleSelectObject={handleSelectObject} 
                                            setIsFilterOpen={setIsFilterOpen} 
                                            FilterCheckbox={FilterCheckbox}
                                            calculateEndDate={calculateEndDate}/>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center pt-[10px] mt-1 shadow-top">
                <button type="button"  onClick={()=>{
                    handleApplyFilter(false); 
                    setIsFilterOpen(false)}} class="clr-btn">Clear All
                </button>
                <button onClick={()=>{
                    if(handleCheck()){
                        setdateError(true)
                        return
                    } else if (selectedDateRange === 'Custom' && selectedFilter ==='date_range' && (FilterCheckbox['start_date']===null || FilterCheckbox['end_date']===null)) {
                        if(selectedDates.start_date === undefined || selectedDates.end_date === undefined ) {
                            setdateError(true)
                            setDateErrorMsg('Both start date and End Date are required.')
                            return 
                        }else {
                            handleApplyFilter(true);
                            setIsFilterOpen(false)
                        }
                    }else {
                        handleApplyFilter(true);
                        setIsFilterOpen(false)
                    }
                    
                }

                } type="button"   id = "apply_filter" class="aply-fltr-btn">Apply Filter(s)
                </button>
            </div>
        </div> 
    );
}

export default memo(Filter);
